import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export default function AffiliateActivation() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [affiliateInfo, setAffiliateInfo] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/api/affiliates/activation/${token}`)
      .then(({ data }) => setAffiliateInfo(data))
      .catch((err) => setError(err?.response?.data?.message || "Lien invalide"))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (password.length < 8) {
      return setError("Le mot de passe doit faire au moins 8 caractères.");
    }
    if (password !== confirm) {
      return setError("Les mots de passe ne correspondent pas.");
    }

    setSubmitting(true);
    try {
      const { data } = await axios.post(
        `${API}/api/affiliates/activation/${token}`,
        { password }
      );
      localStorage.setItem("affiliateToken", data.token);
      navigate("/affilie/dashboard");
    } catch (err) {
      setError(err?.response?.data?.message || "Erreur lors de l'activation");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-100 text-stone-600">
        Chargement…
      </div>
    );
  }

  if (error && !affiliateInfo) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-100 p-6">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <h2 className="text-xl font-bold text-red-600 mb-3">Lien invalide</h2>
          <p className="text-stone-600 mb-6">{error}</p>
          <button
            onClick={() => navigate("/affilie/login")}
            className="px-4 py-2 bg-orange-600 hover:bg-orange-500 text-white rounded-lg font-medium transition"
          >
            Aller à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 to-orange-100 p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-stone-800 mb-2">
            Bienvenue {affiliateInfo.name} 👋
          </h2>
          <p className="text-stone-600">
            Créez votre mot de passe pour accéder à votre espace affilié Blackout Games.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">Email</label>
            <input
              type="email"
              value={affiliateInfo.email}
              disabled
              className="w-full px-3 py-2 rounded-lg bg-stone-100 border border-stone-200 text-stone-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              className="w-full px-3 py-2 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            <p className="text-xs text-stone-500 mt-1">8 caractères minimum</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">
              Confirmer le mot de passe
            </label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className="w-full px-3 py-2 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {error && (
            <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 bg-orange-600 hover:bg-orange-500 text-white rounded-lg font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ? "Activation..." : "Activer mon compte"}
          </button>
        </form>
      </div>
    </div>
  );
}